import { useEffect, useRef, useState } from 'react'

import { ConnectGoalWebSocket, SetGoalSocketMessageHandler, ClearGoalSocketMessageHandler, DisconnectGoalWebSocket, SendTaps } from './../../../utilities/BL/Goal'
import { GoalBase } from './../../Admin/Commons/GoalBase'


const GoalFan = () => {
  const [playerId, setPlayerId] = useState(() => sessionStorage.getItem('goal.player') || '')
  const [status, setStatus] = useState('idle') // connecting | connected | ...
  const [toast, setToast] = useState('')

  const [batchSize, setBatchSize] = useState(5)
  const [flushMs, setFlushMs] = useState(120)

  // estado del match
  const [match, setMatch] = useState({
    matchId: null,
    phase: 'Waiting',
    progressLucho: 0,
    progressTunita: 0,
    tapsParaGanar: 100,
    winner: null
  })

  // Normaliza claves a camelCase de manera superficial (suficiente para tu payload)
  const normalizeKeys = (obj) => {
    if (!obj || typeof obj !== 'object') return obj
    const out = {}
    for (const k of Object.keys(obj)) {
      const ck = k.charAt(0).toLowerCase() + k.slice(1) // MatchId -> matchId
      out[ck] = obj[k]
    }
    return out
  }

  // conectar WS cuando hay player
  useEffect(() => {
    if (!playerId) return
    const t = (m) => { setToast(m); setTimeout(() => setToast(''), 2500) }
    ConnectGoalWebSocket(playerId, setStatus, t).then(() => {
      SetGoalSocketMessageHandler(onMessage)
    })
    return () => { ClearGoalSocketMessageHandler(); DisconnectGoalWebSocket() }
  }, [playerId])

  // handler WS
  const onMessage = (msg) => {
    const type = (msg?.type || '').toLowerCase()

    // normalizamos claves a camelCase
    const p = normalizeKeys(msg?.payload || {})

    switch (type) {
      case 'goal.created': {
        const cfg = normalizeKeys(p.cfg || {})
        if (cfg.tapsPorTick) setBatchSize(cfg.tapsPorTick)
        // opcional: alinea el tiempo de flush con el server
        if (typeof cfg.minUpdateMs === 'number') setFlushMs(Math.max(80, cfg.minUpdateMs))
        break
      }

      case 'goal.layout':

      case 'goal.prepare':
        setMatch(m => ({ ...m, phase: 'Waiting' }))
        break
        
      case 'goal.snapshot': {
        setMatch({
          matchId: p.matchId ?? null,
          phase: p.state ?? 'Waiting',   // ← si viene 'Running', canTap se habilita
          progressLucho: p.progressLucho ?? 0,
          progressTunita: p.progressTunita ?? 0,
          tapsParaGanar: p.tapsParaGanar ?? 100,
          winner: p.winner ?? null
        })
        break
      }

      case 'goal.started':
        setMatch(m => ({ ...m, matchId: p.matchId, phase: 'Running', winner: null }))
        break

      case 'goal.progress': {
        setMatch(m => ({
          ...m,
          phase: (m.phase || '').toLowerCase() === 'running' ? m.phase : 'Running',
          progressLucho: p.progressLucho ?? m.progressLucho,
          progressTunita: p.progressTunita ?? m.progressTunita,
          tapsParaGanar: p.tapsParaGanar ?? m.tapsParaGanar
        }))
        break
      }

      case 'goal.finished':
        setMatch(m => ({
          ...m,
          phase: 'Finished',
          winner: p.winner ?? null,
          progressLucho: p.progressLucho ?? m.progressLucho,
          progressTunita: p.progressTunita ?? m.progressTunita
        }))
        break

      default: break
    }
  }

  // buffer de taps: envía cada N taps o cada X ms (lo que ocurra primero)
  //const batchSize = 5
  //const flushMs = 120
  const bufRef = useRef({ count: 0, timer: null, sending: false })
  //const canTap = playerId && match.phase === 'Running' && !match.winner && match.matchId
  const canTap = Boolean(
    playerId &&
    match.matchId &&
    !match.winner &&
    (match.phase || '').toLowerCase() === 'running'
  )

  const flush = async () => {
    const buf = bufRef.current

    // SIEMPRE limpia el timer al entrar a flush
    if (buf.timer) { clearTimeout(buf.timer); buf.timer = null }

    if (buf.sending || buf.count <= 0 || !match.matchId) return

    const taps = buf.count
    buf.count = 0
    buf.sending = true
    try {
      await SendTaps({ matchId: match.matchId, playerId, taps })
    } catch {
      // si falla, re-acumula
      buf.count += taps
    } finally {
      buf.sending = false
    }
  }

  const onTap = () => {
    if (!canTap) return
    const buf = bufRef.current
    buf.count++

    // Si alcanzaste el batch por conteo, LIMPIA el timer y flushea ya
    if (buf.count >= batchSize) {
      if (buf.timer) { clearTimeout(buf.timer); buf.timer = null }
      flush()
      return
    }

    // Si no hay timer, crea uno para flush por tiempo
    if (!buf.timer) {
      buf.timer = setTimeout(() => {
        buf.timer = null
        flush()
      }, flushMs)
    }
  }

  // Limpieza al desmontar el componente (opcional pero recomendado)
  useEffect(() => {
    return () => {
      const buf = bufRef.current
      if (buf.timer) { clearTimeout(buf.timer); buf.timer = null }
      ClearGoalSocketMessageHandler()
      DisconnectGoalWebSocket()
    }
  }, [])

  if (!playerId) return <SelectPlayer onPick={(p) => { setPlayerId(p); sessionStorage.setItem('goal.player', p) }} />


  return (
    <div className="gfan">
      <div className='gfan__background'>
        <img src='/img/games/runtogoal/fondo-1.png' className='gfan__background__Image' />
        {/* <img src='/img/games/runtogoal/fondo-2.png' className='gfan__background__Image' /> */}
      </div>

      <header className="container Fan__Goal__GameHeader">
        <div>
          <button type='button' className='Btn__Adsl--Red Fan__Goal__GameHeader__Button' onClick={() => { setPlayerId(''); sessionStorage.removeItem('goal.player') }}>
            <i className="bi bi-box-arrow-right"></i> Salir
          </button>
        </div>
        <div>
          <p className="gfan__controls__who text-center mt-4">
            Jugador: <strong>
            {playerId.toUpperCase()} {/* Normal Lucho y Tunita */}
            {/*
              {(playerId && playerId.toUpperCase() === 'LUCHO' ? 'CODITO' : playerId.toUpperCase() === 'TUNITA' ? 'ESTRELLITA' : playerId.toUpperCase())} -> PARA LA MODERNA
              {(playerId && playerId.toUpperCase() === 'LUCHO' ? 'PALOMITA DORADA' : playerId.toUpperCase() === 'TUNITA' ? 'PALOMITA AZUL' : playerId.toUpperCase()) / SnackShow /}
            */}
            </strong>
          </p>
          <p className={`gfan__controls__status gfan__controls__status--${status} text-center`}>{status}</p>
        </div>
      </header>

      <div className='gfan__controls'>
        {match.winner && (
          <p className="gfan__controls__tap__Text">
            {match.winner === 'tie' ? '¡Empate!' : `El ganador es... ${match.winner.toUpperCase()}`}  {/* Normal */}
            {/* {match.winner === 'tie' ? '¡Empate!' : `El ganador es... ${(match.winner && match.winner.toUpperCase() === 'LUCHO' ? 'CODITO' : match.winner.toUpperCase() === 'TUNITA' ? 'ESTRELLITA' : match.winner.toUpperCase())}`} -> PARA LA MODERNA */}
            {/* {match.winner === 'tie' ? '¡Empate!' : `El ganador es... ${(match.winner && match.winner.toUpperCase() === 'LUCHO' ? 'PALOMITA DORADA' : match.winner.toUpperCase() === 'TUNITA' ? 'PALOMITA AZUL' : match.winner.toUpperCase())}` /* SnackShow */}
          </p>
        )}

        {!match.winner && (
          <>
            {canTap && ( <p className='gfan__controls__tap__Text'>¡Comienza!</p> )}
            {!canTap && ( <p className='gfan__controls__tap__Text'>¡Prepárate!</p> )}
          </>
        )}
        <button className={`gfan__controls__tap ${canTap ? '' : 'gfan__controls__tap--disabled'}`} onClick={onTap}>
          <img
            src='/img/games/runtogoal/balon-grande.png' // Lucho y Tunita
            //src='/img/games/runtogoal/la-moderna/balon.png' // Para La Moderna
            //src='/img/games/runtogoal/snackshow/balon.png' // Para SnackShow
            className='gfan__controls__tap__image'
          />
        </button>
        {!match.winner && (
          canTap && ( <p className='gfan__controls__tap__Text'>¡Tap! ¡Tap!</p> )
        )}
        
        {toast && <div className="gfan__controls__toast">{toast}</div>}
      </div>

      <div className='Fan__Goal__Footer'>
        <p className='FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</p>
      </div>
    </div>
  )
}

const SelectPlayer = ({ onPick }) => {
  return (
    <GoalBase classNameApplied={'Fan__Goal__Header'}>
      <div className="Fan__Goal">
        <p className="Fan__Goal__Title">Selecciona tu jugador(a)</p>

        <div className="Fan__Goal__Players">
          <button className="Fan__Goal__Players__Buttons" onClick={() => onPick('lucho')}>
            <img
              src='/img/games/runtogoal/luchito-caricatura.png' // Lucho y Tunita
              //src='img/games/runtogoal/la-moderna/codito.png' // Para La Moderna
              //src='img/games/runtogoal/snackshow/palomita-dorada.png' // Para SnackShow
              className='Fan__Goal__Players__Buttons__Image'
            />
            {/* /img/games/runtogoal/la-moderna/codito.png -> PARA LA MODERNA */}
            <span className='Fan__Goal__Players__Buttons__Text'>
              {/*
                Codito -> PARA LA MODERNA
                Palomita dorada -> PARA SNACKSHOW
              */}
              Lucho
            </span>
          </button>
          
          <button className="Fan__Goal__Players__Buttons" onClick={() => onPick('tunita')}>
            <img
              src='/img/games/runtogoal/tunita-caricatura.png' // Lucho y Tunita
              //src='/img/games/runtogoal/la-moderna/estrella.png' // Para La Moderna
              //src='/img/games/runtogoal/snackshow/palomita-azul.png' // Para SnackShow
              className='Fan__Goal__Players__Buttons__Image'
            />
            <span className='Fan__Goal__Players__Buttons__Text'>
              {/*
                Estrellita -> PARA LA MODERNA
                Palomita azul -> PARA SNACKSHOW
              */}
              Tunita
            </span>
          </button>
        </div>
      </div>
    </GoalBase>
  )
}

export { GoalFan };